module.exports = __webpack_public_path__ + "img/phonetop.33a28126.png";